/*
 * AWR cart toast — site-wide "added to cart" confirmation.
 *
 * Add-to-cart used to bounce the shopper to /cart. Instead every add path calls
 * AWRCart.added(...), which shows an animated toast (item, quantity, cart total)
 * and publishes PUB_SUB_EVENTS.cartUpdate so the header badge re-counts itself.
 */
(function () {
  if (window.AWRCartToast) return;

  var AWR_TOAST_VERSION = '2024-variant-cartline'; // bump on change to confirm the live build
  var AUTO_DISMISS_MS = 5000;
  var MAX_VISIBLE = 3;
  var stack = null;

  function injectStyles() {
    if (document.getElementById('awr-cart-toast-styles')) return;
    var style = document.createElement('style');
    style.id = 'awr-cart-toast-styles';
    style.textContent = [
      '.awr-toast-stack{position:fixed;top:24px;right:24px;z-index:10000;display:flex;flex-direction:column;gap:12px;pointer-events:none;max-width:min(360px,calc(100vw - 32px))}',
      '.awr-toast{pointer-events:auto;position:relative;overflow:hidden;display:flex;gap:12px;padding:14px 14px 16px;border-radius:10px;background:#fff;color:#0d395e;box-shadow:0 10px 30px rgba(9,42,71,.18);border:1px solid #e4e8ee;transform:translateX(120%);opacity:0;transition:transform .35s cubic-bezier(.22,1,.36,1),opacity .35s ease}',
      '.awr-toast.is-visible{transform:translateX(0);opacity:1}',
      '.awr-toast.is-leaving{transform:translateX(120%);opacity:0}',
      '.awr-toast__image{flex:0 0 48px;width:48px;height:48px;object-fit:cover;border-radius:6px;background:#f4f5f7}',
      '.awr-toast__body{flex:1 1 auto;min-width:0;font-size:13px;line-height:1.45}',
      '.awr-toast__heading{display:flex;align-items:center;gap:6px;font-weight:700;font-size:13px;margin:0 0 2px}',
      '.awr-toast__title{font-weight:600;margin:0;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}',
      '.awr-toast__variant{margin:1px 0 0;font-size:11.5px;color:#7a8794}',
      '.awr-toast__meta{margin:2px 0 0;color:#5b6b7c}',
      '.awr-toast__total{margin:6px 0 0;font-weight:600}',
      '.awr-toast__note{margin:2px 0 0;font-size:11.5px;font-weight:600;color:#179a9e}',
      '.awr-toast__links{display:flex;gap:8px;margin-top:12px}',
      '.awr-toast__links a{flex:1 1 0;text-align:center;font-size:12px;font-weight:700;line-height:1;padding:9px 10px;border-radius:6px;text-decoration:none!important;transition:background .15s ease,color .15s ease,border-color .15s ease}',
      '.awr-toast__links a.awr-toast__btn--primary{background:#0d395e!important;color:#fff!important;border:1px solid #0d395e}',
      '.awr-toast__links a.awr-toast__btn--primary:hover{background:#ee9d30!important;border-color:#ee9d30!important;color:#fff!important}',
      '.awr-toast__links a.awr-toast__btn--secondary{background:#fff!important;color:#0d395e!important;border:1px solid #c7d0da}',
      '.awr-toast__links a.awr-toast__btn--secondary:hover{border-color:#0d395e!important;background:#f4f7fa!important}',
      '.awr-toast__close{position:absolute;top:6px;right:6px;border:0;background:none;cursor:pointer;font-size:18px;line-height:1;color:#98a4b3;padding:2px 6px}',
      '.awr-toast__close:hover{color:#0d395e}',
      '.awr-toast__progress{position:absolute;left:0;bottom:0;height:3px;width:100%;background:#22c55e;transform-origin:left;animation:awr-toast-progress linear forwards}',
      '.awr-toast--error .awr-toast__progress{background:#ef4444}',
      '@keyframes awr-toast-progress{from{transform:scaleX(1)}to{transform:scaleX(0)}}',
      '@media (max-width:600px){.awr-toast-stack{top:auto;bottom:16px;left:16px;right:16px;max-width:none}.awr-toast{transform:translateY(120%)}.awr-toast.is-leaving{transform:translateY(120%)}}',
      '@media (prefers-reduced-motion:reduce){.awr-toast{transition:opacity .2s ease;transform:none}.awr-toast.is-leaving{transform:none}.awr-toast__progress{animation:none}}',
    ].join('');
    document.head.appendChild(style);
  }

  function getStack() {
    if (stack && document.body.contains(stack)) return stack;
    injectStyles();
    stack = document.createElement('div');
    stack.className = 'awr-toast-stack';
    stack.setAttribute('role', 'status');
    stack.setAttribute('aria-live', 'polite');
    document.body.appendChild(stack);
    return stack;
  }

  function formatMoney(cents, currency) {
    if (typeof cents !== 'number') return '';
    // currencyDisplay:'narrowSymbol' renders "$" rather than the locale-qualified
    // "A$" for AUD, matching the storefront's money filter output.
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: currency || window.AWRCartToast.currency || 'AUD',
        currencyDisplay: 'narrowSymbol',
      }).format(cents / 100);
    } catch (e) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
          style: 'currency',
          currency: currency || window.AWRCartToast.currency || 'AUD',
        }).format(cents / 100).replace(/^[A-Z]{1,2}\$/, '$');
      } catch (e2) {
        return '$' + (cents / 100).toFixed(2);
      }
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function dismiss(toast) {
    if (!toast || toast.dataset.leaving) return;
    toast.dataset.leaving = 'true';
    toast.classList.remove('is-visible');
    toast.classList.add('is-leaving');
    setTimeout(function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 400);
  }

  /*
   * opts: { title, quantity, image, itemCount, totalPrice, currency, error, duration }
   */
  function show(opts) {
    opts = opts || {};
    var host = getStack();
    var isError = !!opts.error;

    while (host.children.length >= MAX_VISIBLE) dismiss(host.firstElementChild);

    var duration = opts.duration || AUTO_DISMISS_MS;
    var toast = document.createElement('div');
    toast.className = 'awr-toast' + (isError ? ' awr-toast--error' : '');

    var parts = [];
    parts.push('<button type="button" class="awr-toast__close" aria-label="Dismiss">&times;</button>');
    if (opts.image && !isError) {
      parts.push('<img class="awr-toast__image" src="' + escapeHtml(opts.image) + '" alt="" loading="lazy">');
    }

    var body = ['<div class="awr-toast__body">'];
    body.push(
      '<p class="awr-toast__heading">' +
        (isError ? '' : '<span aria-hidden="true">&#10003;</span>') +
        escapeHtml(opts.heading || (isError ? 'Could not add to cart' : 'Added to cart')) +
        '</p>'
    );
    if (opts.title) body.push('<p class="awr-toast__title">' + escapeHtml(opts.title) + '</p>');
    if (!isError && opts.variant) {
      body.push('<p class="awr-toast__variant">' + escapeHtml(opts.variant) + '</p>');
    }
    if (!isError && opts.quantity) {
      body.push('<p class="awr-toast__meta">Quantity: ' + escapeHtml(opts.quantity) + '</p>');
    }
    if (!isError && typeof opts.itemCount === 'number') {
      var count = opts.itemCount;
      var countText = count + (count === 1 ? ' item' : ' items') + ' in cart';
      // For B2B customers the storefront total_price is the pre-discount retail
      // price (the real total is computed by Orbit at checkout / on the cart page),
      // so we show the count and a trade-pricing note instead of a wrong number.
      var discountsApply = window.AWRToast && window.AWRToast.discountsApply;
      if (!discountsApply && typeof opts.totalPrice === 'number') {
        body.push(
          '<p class="awr-toast__total">Cart (' + countText.replace(' in cart', '') + '): ' +
            escapeHtml(formatMoney(opts.totalPrice, opts.currency)) +
            '</p>'
        );
      } else {
        body.push('<p class="awr-toast__total">' + countText + '</p>');
        if (discountsApply) {
          body.push('<p class="awr-toast__note">Trade pricing applied in cart</p>');
        }
      }
    }
    if (!isError) {
      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      body.push(
        '<div class="awr-toast__links">' +
          '<a class="awr-toast__btn--secondary" href="' + escapeHtml(cartUrl) + '">View cart</a>' +
          '</div>'
      );
    }
    body.push('</div>');
    parts.push(body.join(''));
    parts.push('<span class="awr-toast__progress" style="animation-duration:' + duration + 'ms"></span>');

    toast.innerHTML = parts.join('');
    host.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    var timer = setTimeout(function () {
      dismiss(toast);
    }, duration);

    toast.querySelector('.awr-toast__close').addEventListener('click', function () {
      clearTimeout(timer);
      dismiss(toast);
    });
    // Hovering pauses the countdown so the shopper can read/click the links.
    toast.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      var bar = toast.querySelector('.awr-toast__progress');
      if (bar) bar.style.animationPlayState = 'paused';
    });
    toast.addEventListener('mouseleave', function () {
      var bar = toast.querySelector('.awr-toast__progress');
      if (bar) bar.style.animationPlayState = 'running';
      timer = setTimeout(function () {
        dismiss(toast);
      }, 1500);
    });

    return toast;
  }

  window.AWRCartToast = { show: show, dismiss: dismiss, formatMoney: formatMoney };

  /*
   * Broadcasts a cart change so every subscriber (header badge, cart sections)
   * re-renders, and returns the fresh cart. `added` additionally toasts.
   */
  function fetchCart() {
    var url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function notifyUpdate(cart, source) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: source || 'awr-cart', cartData: cart });
    }
    document.dispatchEvent(new CustomEvent('awr:cart:updated', { detail: cart }));
  }

  /*
   * Builds the "variation" line shown under the title, e.g. "Black / 900mm".
   * Prefers the variant title, falls back to the individual option values, and
   * appends any public line-item properties (skips Shopify's private _keys).
   */
  function variantLabel(item) {
    if (!item) return '';
    var label = '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      label = item.variant_title;
    } else if (Array.isArray(item.options_with_values)) {
      label = item.options_with_values
        .map(function (o) { return o && o.value; })
        .filter(function (v) { return v && v !== 'Default Title'; })
        .join(' / ');
    }
    if (item.properties) {
      var props = Object.keys(item.properties)
        .filter(function (k) { return k.charAt(0) !== '_' && item.properties[k]; })
        .map(function (k) { return item.properties[k]; });
      if (props.length) label = label ? label + ' · ' + props.join(' · ') : props.join(' · ');
    }
    return label;
  }

  /*
   * response: the /cart/add.js payload (single item, or { items: [...] }).
   * Falls back to a plain confirmation when the payload shape is unfamiliar.
   */
  function added(response, options) {
    options = options || {};
    var items = [];
    if (response && Array.isArray(response.items)) items = response.items;
    else if (response && response.id) items = [response];

    var quantity = items.reduce(function (sum, item) {
      return sum + (item.quantity || 0);
    }, 0);
    var title =
      options.title ||
      (items.length === 1 ? items[0].product_title || items[0].title : items.length + ' products');
    var image = options.image || (items.length === 1 ? items[0].image : null);

    // Derive the variation up front from the add response so it shows even if the
    // follow-up cart fetch is stale or fails. options.variant (incl. '') wins.
    var variant = options.variant;
    if (variant === undefined) {
      variant = items.length === 1 ? variantLabel(items[0]) : '';
    }

    return fetchCart()
      .then(function (cart) {
        notifyUpdate(cart, options.source);

        // If the response was thin, upgrade the label from the matching cart line
        // (richest source), matched by line key then variant id.
        if (options.variant === undefined && items.length === 1) {
          var addedItem = items[0];
          var cartItems = cart.items || [];
          var line =
            cartItems.filter(function (ci) { return ci.key === addedItem.key; })[0] ||
            cartItems.filter(function (ci) { return ci.id === (addedItem.variant_id || addedItem.id); })[0];
          if (line) {
            var richer = variantLabel(line);
            if (richer) variant = richer;
          }
        }

        show({
          title: title,
          variant: variant,
          quantity: options.quantity || quantity || 1,
          image: image,
          itemCount: cart.item_count,
          totalPrice: cart.total_price,
          currency: cart.currency,
        });
        return cart;
      })
      .catch(function () {
        show({ title: title, variant: variant, quantity: options.quantity || quantity || 1 });
      });
  }

  function error(message) {
    show({ error: true, title: message || 'Please try again.' });
  }

  window.AWRCart = { added: added, error: error, refresh: fetchCart, notifyUpdate: notifyUpdate, show: show, version: AWR_TOAST_VERSION };

  /*
   * Global cart-mutation watcher.
   *
   * The badge should update after ANY cart change, not only the paths we wired
   * to AWRCart.added(). So we wrap fetch and XMLHttpRequest: whenever a request
   * to a mutating cart endpoint (/cart/add|change|update|clear) finishes, we
   * re-fetch the cart once and broadcast it. This also covers legacy jQuery
   * $.ajax paths (they use XHR under the hood) with no per-call changes.
   */
  (function watchCartMutations() {
    var MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
    var refreshTimer = null;

    function scheduleRefresh() {
      // Debounce bursts (e.g. quick-order adds items one AJAX call at a time)
      // into a single cart fetch.
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        fetchCart()
          .then(function (cart) {
            // Badge-only broadcast. We deliberately do NOT publish the pubsub
            // cartUpdate here: on the cart page cart.js re-renders itself on any
            // pubsub event, so a full broadcast would double-render (flicker /
            // focus loss). The header badge listens to this DOM event directly.
            document.dispatchEvent(new CustomEvent('awr:cart:updated', { detail: cart }));
          })
          .catch(function () {});
      }, 150);
    }

    function isMutation(url) {
      return typeof url === 'string' && MUTATION_RE.test(url);
    }

    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : input && input.url;
        var result = origFetch.apply(this, arguments);
        if (isMutation(url)) {
          result.then(function (res) {
            if (res && res.ok) scheduleRefresh();
          }).catch(function () {});
        }
        return result;
      };
    }

    if (window.XMLHttpRequest) {
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__awrCartMutation = isMutation(url);
        return origOpen.apply(this, arguments);
      };
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        if (this.__awrCartMutation) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) scheduleRefresh();
          });
        }
        return origSend.apply(this, arguments);
      };
    }
  })();
})();
